export const CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE = 'CUSTOMER_AGENT_MAINTENANCE_MODE_MESSAGE';